import { render, staticRenderFns } from "./BookingSimpleViewModal.vue?vue&type=template&id=5b7d8b6c"
import script from "./BookingSimpleViewModal.vue?vue&type=script&lang=js"
export * from "./BookingSimpleViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports